import { Typography } from '@mui/material';
import i18next from 'i18next';
import { memo } from 'react';

import { MultiStoreDot } from './multi-store-dot';

// Legenda del puntino sotto gli orari, solo quando almeno un giorno o un orario lo mostra
export const MultiStoreLegend = memo(function MultiStoreLegend(): JSX.Element {
  return (
    <div className="multi-store-legend">
      <MultiStoreDot />
      <Typography variant="contentDescription2">
        {i18next.t('pages.when.multi_store.elsewhere_only')}
      </Typography>
    </div>
  );
});
